import { Grid } from "@material-ui/core";
import styled from "styled-components";

export const SkeletonWrapperWelcomeMsg = styled.div`
    width: 100%;
    display: flex;
    justify-content: start;
    flex-flow: column;
    padding: 20px 0px;
`;

export const GridWithPadding = styled(Grid) <{ $isMobile?: boolean; $hasWarnings: boolean }>`
    &.MuiGrid-item {
        ${({ $isMobile }) =>
        $isMobile &&
        `
            padding-bottom: 35px;
        `}

        ${({ $hasWarnings }) =>
        !$hasWarnings &&
        `
            margin-top: 32px;
        `}
    }
`;
